<script setup lang="ts">
import {PropType} from "vue";
import {ICellRendererParams} from "ag-grid-community";
import NamaIcon from "@/components/icons/NamaIcon.vue";
import OwnerType from "@/utils/constants/OwnerType.ts";
import PreferencesRequest from "@/utils/constants/PreferencesRequest.ts";
import MetaData from "@/utils/common/MetaData.ts";
import {Dialog} from "quasar";
import SimpleEntityDialog from "@/components/dialogs/SimpleEntityDialog.vue";
import Translator from "@/utils/common/Translator.ts";
import {SimpleEntityMenuItem} from "@/utils/UIConstants/MoreMenuItem.ts";
import CriteriaBuilder from "@/utils/criteria/CriteriaBuilder.ts";
import CommonFieldIds from "@/utils/constants/CommonFieldIds.ts";
import FetchPreferencesRequest = namaTypes.FetchPreferencesRequest;
import BaseEntityDTO = namaTypes.BaseEntityDTO;
import DTOCriteria = namaTypes.DTOCriteria;

const props = defineProps({
  params: {
    type: Object as PropType<ICellRendererParams>,
    required: true
  }
});

const fieldValue = props.params.value;
const entityType: string = props.params?.entityType;
const id = "showGeneratedSystemTransaction";

async function showGeneratedSystemTransaction() {
  let request: FetchPreferencesRequest = {
    owner: {
      ownerType: OwnerType.Entity,
      ownerId: entityType
    },
    properties: [PreferencesRequest.EDIT_LAYOUT, PreferencesRequest.META_DATA]
  };
  await MetaData.fetchPreferences(request, async (result: Record<any, any> | null) => {
    if (!result)
      return;
    let record: BaseEntityDTO | undefined;
    let criteria: DTOCriteria | undefined = CriteriaBuilder.create().field(CommonFieldIds.ID).equal(fieldValue).build();
    record = await SimpleEntityMenuItem.fetchSimpleEntity(entityType, criteria);
    Dialog.create({
      component: SimpleEntityDialog,
      componentProps: {
        editLayout: result.editLayout,
        metaData: result.metaData,
        object: record ?? {},
        entityType: entityType,
        title: Translator.translateId(id)
      }
    });
  });
}

</script>

<template>
  <q-item v-if="fieldValue" dense class="tw-px-0 tw-w-full tw-h-full">
    <q-item-section>
      <div class="tw-flex tw-items-center tw-gap-2.5 tw-self-center">
        <NamaIcon default-icon="nm-prevent-option" class="tw-size-5 tw-cursor-pointer" @click.stop="showGeneratedSystemTransaction"/>
      </div>
    </q-item-section>
  </q-item>
</template>
